import { render } from "./OrderManager.vue?vue&type=template&id=2cc74a40"
import script from "./OrderManager.vue?vue&type=script&lang=js"
export * from "./OrderManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__